module.exports = __webpack_public_path__ + "img/collection-weddingRingsRingSets.a34934c.webp";